module.exports = __webpack_public_path__ + "static/media/use_esim_zhcn2.13943eab.png";